import { apiClient } from "../../base/ApiClient";


//  post RecordAbsence of document
export const createRecordAbsence = async (RecordAbsenceData) => {
  const response = await apiClient.post(`/client/record-absences/`, RecordAbsenceData);
  return response.data;
};

//    get All RecordAbsence of document
export const getRecordAbsence = async (client_id) => {
  const response = await apiClient.get(`/client/record-absences/?client_id=${client_id}`);
  return response.data;
};

// delete RecordAbsence
export const deleteRecordAbsence = async (id) => {
  const response = await apiClient.delete(`/client/record-absences/${id}/`);
  return response.data;
};

// get RecordAbsence by id for edit
export const getRecordAbsenceById = async (id) => {
  const response = await apiClient.get(`/client/record-absences/${id}/`);
  return response.data;
};

// edit RecordAbsence
export const updateRecordAbsence = async (id, data) => {
  const response = await apiClient.put(`/client/record-absences/${id}/`,data);
  return response.data;
};